"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Alpine.js component for the video block. Contains a placeholder video and a youtube video
 * that is activated by clicking a play button.
 *
 * @param args - The data object containing the properties for the video block component.
 * @returns The Alpine.js component object.
 */
// sets to true on first nit, prevents multiple video blocks from reloading the iframe api
let init = false;
//resolves when the youtube iframe api is ready.
//https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
let initPromise;
// I do not know why but actualy typing args correctly causes problems. So it is unknown
// then typecast to the right object at the start of the block
exports.default = (args) => {
    const videoArgs = args;
    return {
        init() {
            setUpApi();
        },
        showEmbed: false,
        url: videoArgs.url,
        id: videoArgs.id,
        toggle() {
            this.showEmbed = true;
            this.initEmbed();
        },
        initEmbed() {
            initPromise.then(() => {
                console.log(this.url);
                new YT.Player(this.id, {
                    videoId: this.url,
                    host: 'https://www.youtube.com',
                    playerVars: {
                        'rel': 0,
                    },
                    events: {
                        onReady: event => {
                            event.target.playVideo();
                        },
                    }
                });
            });
        },
    };
};
function setUpApi() {
    if (!init) {
        init = true;
        initPromise = new Promise(resolve => {
            window.onYouTubeIframeAPIReady = () => {
                resolve();
            };
            var tag = document.createElement("script");
            // tag.type = 'text/plain';
            tag.src = "https://www.youtube.com/iframe_api";
            // tag.setAttribute("data-cookieconsent", "preferences");
            const firstScriptTag = document.getElementsByTagName("script")[0];
            if (firstScriptTag && firstScriptTag.parentNode) {
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
        });
    }
    return initPromise;
}
/**
 * Lazy-load video
 */
document.addEventListener("DOMContentLoaded", function (event) {
    const lazyVideos = Array.from(document.querySelectorAll("video.lazy"));
    if ("IntersectionObserver" in window) {
        const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    Array.from(entry.target.children).forEach((source) => {
                        if (source.tagName.toLowerCase() === "source") {
                            const videoSource = source;
                            videoSource.src = videoSource.dataset.src;
                        }
                    });
                    entry.target.load();
                    entry.target.classList.remove("lazy");
                    lazyVideoObserver.unobserve(entry.target);
                }
            });
        });
        lazyVideos.forEach(lazyVideo => {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
});
